import type { ReactNode } from 'react';
import { ApiError } from '../lib/api-client';
import { phrase } from '../lib/i18n/runtime';
import { errorMessage } from '../lib/errors';

function phraseNode(node: ReactNode): ReactNode {
  return typeof node === 'string' ? phrase(node) : node;
}

/** Announces an error (role="alert") with any field-level details from the server. */
export function ErrorNotice({ error, title }: { error: unknown; title?: string }) {
  if (error === null || error === undefined) {
    return null;
  }
  const details = error instanceof ApiError ? (error.details ?? []) : [];
  return (
    <div className="notice notice--down" role="alert">
      <span aria-hidden="true">⚠ </span>
      {title !== undefined && <strong>{phrase(title)}: </strong>}
      {phrase(errorMessage(error))}
      {details.length > 0 && (
        <ul className="notice__details">
          {details.map((detail) => (
            <li key={`${detail.path}:${detail.code}`}>
              {detail.path !== '' ? `${detail.path}: ` : ''}
              {phrase(detail.message)}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export function SuccessNotice({ children }: { children: ReactNode }) {
  return (
    <p className="notice notice--ok" role="status">
      <span aria-hidden="true">✓ </span>
      {phraseNode(children)}
    </p>
  );
}

export function LoadingNotice({ children }: { children: ReactNode }) {
  return (
    <p className="meta" role="status" aria-live="polite">
      {phraseNode(children)}
    </p>
  );
}
